import { gql } from '@apollo/client'

export const GET_DASHBOARD_ACTIVITY_WATER_TRUCK_REQUEST = gql`
  query GetActivityWaterTruckRequestCountersByRol(
    $filters: countActivityWaterTruckRequestFilterInput
  ) {
    getActivityWaterTruckRequestCountersByRol(filters: $filters) {
      activityWaterTruckRequest {
        total
        generated
        completed
        canceled
        averageCompleted
        totalCompleted
        averageCanceled
        labels
        reportsByService {
          type_delivery
          total
          percentage
          generated
          resolved
        }
        reportsByProvider {
          card_name
          total
          percentage
          provider_id
          generated
          resolved
          dataDates {
            label
            generated
            completed
          }
        }
        # countersByDateFilter {
        #   id
        #   label
        #   generated
        #   effectivity
        #   resolved
        #   canceled
        #   averageCanceled
        # }
      }
    }
  }
`

export const GET_DATA_FOR_FILTERS_DASHBOARD_WATER_TRUCK_REQUEST = gql`
  query GetActivityWaterTruckRequestFilteres(
    $filters: countActivityWaterTruckRequestFilterInput
  ) {
    getActivityWaterTruckRequestFilteres(filters: $filters) {
      months {
        value
        label
      }
      weeks {
        value
        label
      }
      years {
        value
        label
      }
    }
  }
`
